import React from 'react'
import {
  CloudUploadOutlined,
  InfoOutlined,
  CallSplitOutlined,
  FormatListNumbered,
  SpeakerNotesOutlined,
} from '@material-ui/icons'

export const packPageTabs = [
  {
    label: 'Details',
    value: 'details',
    icon: <InfoOutlined />,
  },
  {
    label: 'Upload',
    value: 'upload',
    icon: <CloudUploadOutlined />,
  },
  {
    label: 'Publish',
    value: 'publish',
    icon: <CallSplitOutlined />,
  },
  {
    label: 'Revisions',
    value: 'revisions',
    icon: <FormatListNumbered />,
  },
  {
    label: 'History',
    value: 'history',
    icon: <SpeakerNotesOutlined />,
  },
]
